import { MeddraControllerApi } from '@/lib/api/generated/casedb';
import { catalogApiClient } from '../../shared/services/catalogApiClient';
export async function dictionaryReleases() {
  return (await (await catalogApiClient(MeddraControllerApi)).releases()).data;
}
export async function dictionarySearch(query: string, version: string, language: string, offset: number, signal?: AbortSignal) {
  return (await (await catalogApiClient(MeddraControllerApi)).searchMeddra(query, version, language, offset, 20, { signal, headers: { 'X-Skip-Loading': 'true' } })).data;
}
export async function dictionaryTerm(code: string, version: string, language: string) {
  return (await (await catalogApiClient(MeddraControllerApi)).meddraTerm(code, version, language)).data;
}
